/*!

=========================================================
* Black SalesDashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import MarketingDashboard from "views/MarketingDashboard.js";
import SalesDashboard from "views/SalesDashboard.js";
import AiCallInsights from "views/AiCallInsights.js";

import CompareMap from "views/CompareMap";
import LeadProcess from "views/LeadProcess";
import Leadmap from "views/Leadmap";
import LeadScore from "views/LesadScore";
import RegionEditor from "views/RegionEditor";
import RottingDeals from "views/RottingDeals";
import Teams from "views/Teams";
import Dialer from "./views/Dialer";
import Duplicates from "./views/Duplicates";
import PizzaTrackerConfig from './views/PizzaTrackerConfig';
import RoleManagement from "./views/RoleManagement";
import Inventory from "./views/inventory/Inventory";
import Cogs from './views/inventory/cogs';
import ProductSync from "./views/ProductSync";
import ProductSearchOverrides from "./views/ProductSearchOverrides";

import CalendlyMap from "views/CalendlyMap";

var routes = [
  {
    path: "/reports/menu",
    name: "Reports",
    rtlName: "Reports",
    icon: "fa fa-area-chart",
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    hasSubRoutes: true,
    collapsed: true
  },
  {
    path: "/sales-dashboard",
    name: "Sales Dashboard",
    rtlName: "Sales Dashboard",
    // icon: "tim-icons icon-chart-pie-36",
    icon: "fa fa-money",
    component: SalesDashboard,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/marketing-dashboard",
    name: "Marketing Dashboard",
    rtlName: "Marketing Dashboard",
    // icon: "tim-icons icon-chart-pie-36",
    icon: "fa fa-graduation-cap",
    component: MarketingDashboard,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/product-sync",
    name: "Product Synchronization",
    rtlName: "Product Synchronization",
    icon: "fa fa-refresh",
    component: ProductSync,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/product-search-overrides",
    name: "Product Search Overrides",
    rtlName: "Product Search Overrides",
    icon: "fa fa-search",
    component: ProductSearchOverrides,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/dialer",
    name: "Dialer",
    rtlName: "Dialer",
    icon: "tim-icons icon-sound-wave",
    component: Dialer,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
  },
  {
    path: "/ai-call-insights",
    name: "AI Call Insights",
    rtlName: "AI Call Insights",
    icon: "fa fa-microphone",
    component: AiCallInsights,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
  },
  {
    path: "/inventory/menu",
    name: "Inventory",
    rtlName: "Inventory",
    icon: "fa fa-truck",
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    hasSubRoutes: true,
    collapsed: true
  },
  {
    path: "/inventory/stock",
    name: "Stock Levels",
    rtlName: "Inventory",
    icon: "fa fa-bar-chart",
    component: Inventory,
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    IsSubRoute: true
  },
  {
    path: "/inventory/cogs",
    name: "COGS",
    rtlName: "SGOC",
    icon: "fa fa-cog",
    component: Cogs,
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    IsSubRoute: true
  },
  {
    path: "/maps/menu",
    name: "Maps",
    rtlName: "Maps",
    icon: "fa fa-map-marker",
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    hasSubRoutes: true,
    collapsed: true
  },
  {
    path: "/lead-map",
    name: "Lead Map",
    rtlName: "Lead Map",
    icon: "tim-icons icon-pin",
    component: Leadmap,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/leads-compare-market",
    name: "CSV Leads Map",
    rtlName: "CSV Leads Map",
    icon: "tim-icons icon-pin",
    component: CompareMap,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/region-editor",
    name: "Region Editor",
    rtlName: "Region Editor",
    icon: "tim-icons icon-compass-05",
    component: RegionEditor,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  }, {
    path: "/tools/menu",
    name: "Quick Tools",
    rtlName: "Quick Tools",
    icon: "fa fa-cogs",
    layout: "/admin",
    public: false,
    RoleLevel: 20,
    hasSubRoutes: true,
    collapsed: true
  },
  {
    path: "/rotting-deals",
    name: "Rotting Deals",
    rtlName: "Rotting Deals",
    icon: "fa fa-crosshairs",
    component: RottingDeals,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/pipedrive-teams",
    name: "Pipedrive Teams",
    rtlName: "Pipedrive Teams",
    icon: "tim-icons icon-single-02",
    component: Teams,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  {
    path: "/role-management",
    name: "User Roles",
    rtlName: "User Roles",
    icon: "fa fa-superpowers",
    component: RoleManagement,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  {
    path: "/duplicates",
    name: "Duplicate Deals",
    rtlName: "Duplicate Deals",
    icon: "tim-icons icon-scissors",
    component: Duplicates,
    layout: "/admin",
    public: false,
    RoleLevel: 10,
    IsSubRoute: true,
  },
  {
    path: "/tracker-config",
    name: "Tracker Config",
    rtlName: "Tracker Config",
    icon: "fa fa-address-card",
    component: PizzaTrackerConfig,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  {
    path: "/processed-leads",
    name: "Processed Leads",
    rtlName: "Processed Leads",
    icon: "fa fa-bullseye",
    component: LeadProcess,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  {
    path: "/lead-scores",
    name: "Lead Scores",
    rtlName: "Lead Scores",
    icon: "fa fa-bullseye",
    component: LeadScore,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  {
    path: "/calendly-map",
    name: "Calendly Map",
    rtlName: "Calendly Map",
    icon: "fa fa-calendar-alt",
    component: CalendlyMap,
    layout: "/admin",
    public: false,
    RoleLevel: 5,
    IsSubRoute: true,
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: "tim-icons icon-atom",
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   rtlName: "إخطارات",
  //   icon: "tim-icons icon-bell-55",
  //   component: Notifications,
  //   layout: "/admin"
  // },
  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   rtlName: "ملف تعريفي للمستخدم",
  //   icon: "tim-icons icon-single-02",
  //   component: UserProfile,
  //   layout: "/admin"
  // },
  // {
  //   path: "/tables",
  //   name: "Table List",
  //   rtlName: "قائمة الجدول",
  //   icon: "tim-icons icon-puzzle-10",
  //   component: TableList,
  //   layout: "/admin"
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: "tim-icons icon-align-center",
  //   component: Typography,
  //   layout: "/admin"
  // },
];
export default routes;
